import { gql } from "@/services/httpAdapter.ts";
import { SalesMetricsFragment } from "../../fragments/salesLog/salesLog";

export const onUpdateSalesLog = gql`
	subscription onUpdateSalesLogSales($locationId: String, $commissionCycleId: String) {
		onUpdateSalesLogSales(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			locationId
			commissionCycleId
			title
			period
			createdAt
			createdBy
			updatedAt
			updatedBy
			analytics {
				totalMonthDays
				new {
					_id
					franchiseName
					salesMetrics {
						_id
						summary {
							deliveredToday
							totalDelivered
							salesPace
							daysWorked
							tradePace
							totalTrades
							tradesToday
						}
						daily {
							frontGross
							frontPVR
							backGross
							backPVR
							totalGross
							totalPVR
							heldGross
							heldPVR
							tradeGrossPace
						}
						projection {
							current {
								frontGross
								frontPVR
								backGross
								backPVR
								totalGross
								totalPVR
								heldGross
								heldPVR
								tradeGrossPace
							}
							projected {
								frontGross
								frontPVR
								backGross
								backPVR
								totalGross
								totalPVR
								heldGross
								heldPVR
								tradeGrossPace
							}
						}
						trades {
							total
							held
							perTrade
							pace
						}
					}
				}
				preOwned {
					_id
					franchiseName
				}
				totals {
					_id
					franchiseName
				}
			}
			dynamicPVRInfo {
				analyticReportName
				minValue
				maxValue
				average
			}
			pvrMaxGraphValues {
				maxNewVehiclesPVR
				maxPreOwnedVehiclesPVR
				maxFinancePVR
				maxTotalPVR
			}
		}
	}
`;

export const onCalculateSalesLogAnalytics = gql`
	subscription onCalculateSalesLogAnalytics($locationId: String, $commissionCycleId: String) {
		onCalculateSalesLogAnalytics(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			locationId
			analytics {
				totalMonthDays
				new {
					franchiseName
					salesMetrics {
						...SalesMetrics
					}
				}
				preOwned {
					franchiseName
					salesMetrics {
						...SalesMetrics
					}
				}
				totals {
					salesMetrics {
						...SalesMetrics
					}
				}
				wholesale {
					salesMetrics {
						...SalesMetrics
					}
				}
			}
			dynamicPVRInfo {
				analyticReportName
				minValue
				maxValue
				average
			}
			pvrMaxGraphValues {
				maxNewVehiclesPVR
				maxPreOwnedVehiclesPVR
				maxFinancePVR
				maxTotalPVR
			}
			updatedAt
		}
	}
	${SalesMetricsFragment}
`;
